var global = window
let tooltipHide = null;

global.initTooltips = function(targetSelector) {
    $(targetSelector).find('[title]:not(.protip)').each(function() {
        if ($(this).attr('title')) {
            let protipItems = $(this).attr('data-tip-title', $(this).attr('title')).not('.protip').not('iframe');

            protipItems.mouseenter(function(event) {
                event.stopPropagation();
                if (tooltipHide) {
                    clearTimeout(tooltipHide);
                    tooltipHide = null;
                }
                let container = $('body > .protip-containers');
                if (!container.length) {
                    container = $('<div class="protip-containers"></div>')
                    $('body').append(container);
                    container.append('<div class="protip-container" style="max-width: 600px; min-width: 184px; transform: translateX(-50%) translateY(-100%);" data-pt-position="top"><span class="protip-arrow"></span><i class="fa"></i><div class="protip-content"></div></div>');
                }
                const el = $(this);
                const icon = el.data('tip-icon');
                const title = el.data('tip-title');
                const scheme = el.data('tip-scheme') || 'default';
                const requestedPosition = el.data('tip-position') || 'top';

                const tooltip = $('.protip-containers .protip-container');
                const tooltipIcon = tooltip.find('.fa');
                const tooltipArrow = tooltip.find('.protip-arrow');

                tooltip.attr('class', 'visible protip-container protip-skin-default protip-skin-default--size-normal protip-skin-default--scheme-' + scheme + ' protip-show');
                tooltip.find('.protip-content').html(title);
                tooltip.data('str', el.get(0).toString());

                if (icon) {
                    tooltipIcon.show().attr('class', 'fa ' + icon);
                } else {
                    tooltipIcon.hide();
                }

                $('.tooltiped').removeClass('tooltiped');
                el.addClass('tooltiped');

                // Calcul intelligent du placement par rapport au viewport
                const elOffset = el.offset();
                const elWidth = el.outerWidth() || 0;
                const elHeight = el.outerHeight() || 0;
                const tipWidth = tooltip.outerWidth() || 0;
                const tipHeight = tooltip.outerHeight() || 0;

                const winWidth = $(window).width();
                const winHeight = $(window).height();
                const scrollTop = $(window).scrollTop();
                const scrollLeft = $(window).scrollLeft();

                const elViewportTop = elOffset.top - scrollTop;
                const elViewportBottom = winHeight - (elViewportTop + elHeight);
                const elCenterLeft = elOffset.left + (elWidth / 2);

                const margin = 10;
                const offsetDistance = 12;

                // Décision de la position verticale (top par défaut, ou flip vers bottom si pas assez d'espace au-dessus)
                let actualPosition = requestedPosition;
                if (actualPosition === 'top' && (elViewportTop - tipHeight - offsetDistance < margin) && elViewportBottom > elViewportTop) {
                    actualPosition = 'bottom';
                } else if (actualPosition === 'bottom' && (elViewportBottom - tipHeight - offsetDistance < margin) && elViewportTop > elViewportBottom) {
                    actualPosition = 'top';
                }

                // Calcul du Y
                let topPos;
                if (actualPosition === 'bottom') {
                    topPos = elOffset.top + elHeight + offsetDistance;
                    tooltip.css('transform', 'translateX(-50%) translateY(0)');
                } else {
                    topPos = elOffset.top - offsetDistance;
                    tooltip.css('transform', 'translateX(-50%) translateY(-100%)');
                }

                // Calcul du X avec clamp pour éviter que le tooltip ne déborde à gauche ou à droite de l'écran
                const minCenterX = scrollLeft + (tipWidth / 2) + margin;
                const maxCenterX = scrollLeft + winWidth - (tipWidth / 2) - margin;
                const clampedCenterX = Math.max(minCenterX, Math.min(elCenterLeft, maxCenterX));
                const leftShift = clampedCenterX - elCenterLeft;

                tooltip.css({
                    left: clampedCenterX + 'px',
                    top: topPos + 'px'
                });

                // Mettre à jour l'orientation et centrer la flèche précisément sur l'élément déclencheur
                tooltip.attr('data-pt-position', actualPosition);
                if (tooltipArrow.length) {
                    // Position standard centrée (50%) compensée du décalage (shift) subi par le conteneur
                    const arrowLeftPercent = 50 - ((leftShift / (tipWidth || 1)) * 100);
                    // Garder la flèche à l'intérieur du corps de l'infobulle
                    const clampedArrowPercent = Math.max(10, Math.min(arrowLeftPercent, 90));
                    tooltipArrow.css({
                        left: clampedArrowPercent + '%',
                        right: 'auto',
                        marginLeft: '-8px'
                    });
                }
            });

            protipItems.mouseleave(function(event) {
                event.stopPropagation();
                const el = $(this);

                if (tooltipHide) {
                    clearTimeout(tooltipHide);
                    tooltipHide = null;
                }

                tooltipHide = setTimeout(function() {
                    const tooltip = $('.protip-containers .protip-container');
                    $('.tooltiped').removeClass('tooltiped');
                    // if (el.get(0).toString() == tooltip.data('id') || strip_tags(tooltip.find('.protip-content').text()) == strip_tags(el.data('tip-title')))
                    $('.protip-container').removeClass('visible');

                    tooltipHide = setTimeout(function() {
                        const tooltip = $('.protip-containers .protip-container');
                        $('.protip-container').addClass('hidden');
                    }, 250)
                }, 10)
            });

            protipItems.addClass('protip');
            $(this).removeAttr('title')
        }
    });

    /*
    $.protip({
        "selector":           '.protip',
        "namespace":          'tip',
        "observer":           false,
        "delayResize":        100,
        "iconTemplate":     '<i class="fa {icon}"></i>',
        "defaults":           {
            "position": 'top',
            "offset-top": 20,
            "scheme": 'default'
        }
    });
    */
}

global.removeTooltips = function(targetSelector) {
    $(targetSelector).find('.protip').each(function() {
        $('[data-pt-identifier='+$(this).data('tipIdentifier')+']').remove();
    })
}
